import { IComponentOptions } from "angular";

import { GtmhubController } from "@gtmhub/core";
import { IModalService } from "angular-ui-bootstrap";
export class UsersSelectorCtrl extends GtmhubController {
  // bindings
  selected: string[];
  excluded: string[];

  static $inject = ["$uibModal"];

  constructor(private $uibModal: IModalService) {
    super();
  }

  openSelectorModal(): void {
    this.$uibModal.open({
      templateUrl: require("./users-selector-modal.jade"),
      backdrop: false,
      windowClass: "fixed-selector modal-small modal",
      controller: "MultiUserSelectorCtrl",
      resolve: {
        alreadySelectedUsers: () => {
          return this.selected;
        },
        excludedUsers: () => {
          return this.excluded;
        },
      },
    });
  }
}

export const UsersSelectorComponent: IComponentOptions = {
  controller: UsersSelectorCtrl,
  templateUrl: require("./users-selector.jade"),
  bindings: {
    selected: "<",
    excluded: "<",
  },
};
